import angular from 'angular';
import orgDataService from '../data/org.data.service';
import ISharedModelService from './ISharedModel.service';


let _orgDataService;

export class TheSafeSharedModelService extends ISharedModelService {
  constructor(
    $q,
    orgDataService // eslint-disable-line no-shadow
  ) {
    super('theSafe');

    /* Private Members */
    _orgDataService = orgDataService;

    /* Public Properties */
    /*
     * NOTE: The "legacy" properties below support the strategy
     * that clients access this service's properties directly, and must
     * watch the "dfdRefresh" promise to know when the properties
     * have values. This can result in accidental race conditions, hiding errors
     * in the original $http promise, and extra code complexity.
     *
     * The new way is for clients to not use these properties at all.
     * Instead, "smart components" (top level components) call these methods and get
     * the data they need in the .then() and put the resolved data into their scopes.
     * "Dumb components" should continue to receive scope properties through their attributes.
     *
     * Clients should avoid mutating the data received from these functions if at all possible.
     * Instead, look to see if you can add a function here that returns the changed state.
     * This service should end up having many getters and setters.
     */
    /**
     * @deprecated Use get method that returns a promise instead (may need to implement)
     */
    this.states = null;
    /**
     * @deprecated Use get method that returns a promise instead (may need to implement)
     */
    this.dfdRefreshStates = $q.defer();

    console.log('app.services.theSafeSharedModelService created');
  }

  /**
   * Returns a cached promise, or fetches the States data
   * @public
   * @async
   * @param {Boolean} forceRefresh - True if api call must occur, default is false
   * @returns {Promise<Array>} - Promise that resolves to a collection of states
   */
  getStates(forceRefresh = false) {
    if (forceRefresh || !this.cache.states) {
      this.cache.states = _orgDataService.getStates()
        .then((response) => {
          const states = response.data.result;

          this.states = states; // legacy
          this.dfdRefreshStates.resolve();// legacy
          return states;
        });
    }
    return this.cache.states;
  }

  /**
   * Returns a cached promise, or fetches the States data
   * @public
   * @async
   * @param {Boolean} forceRefresh - True if api call must occur, default is false
   * @returns {Promise<Array>} - Promise that resolves to a collection of states
   */
  getProvinces(forceRefresh = false) {
    if (forceRefresh || !this.cache.provinces) {
      this.cache.provinces = _orgDataService.getProvinces()
        .then((response) => {
          const provinces = response.data.result;

          this.provinces = provinces; // legacy
          this.dfdRefreshStates.resolve();// legacy
          return provinces;
        });
    }
    return this.cache.provinces;
  }

  /**
   * Forces an api call to fetch States
   * @public
   * @returns {Promise} API States object
   */
  refreshStates() {
    return this.getStates(true);
  }
}

TheSafeSharedModelService.$inject = ['$q', 'orgDataService'];
export default angular.module('app.services.theSafeSharedModelService', [orgDataService])
  .service('theSafeSharedModelService', TheSafeSharedModelService)
  .name;
